import React from "react"
import PropTypes from "prop-types"

const AllButton = ({
  checkedState,
  setCheckedState,
  setCurrentPage,
  setId,
  length,
}) => {
  return (
    <button
      className={`text-sm border rounded py-2 px-3 my-2.5 mr-5 transition duration-300 ease-in-out hover:text-white hover:bg-amber-400 hover:border-amber-400 sm:my-0 sm:mb-5 ${
        checkedState.includes(true)
          ? "text-neutral-600 border-neutral-600"
          : "text-white bg-amber-400 border-amber-400"
      }`}
      onClick={() => {
        setId([])
        setCheckedState(new Array(length).fill(false))
        setCurrentPage(1)
      }}
    >
      全部
    </button>
  )
}

AllButton.propTypes = {
  checkedState: PropTypes.array,
  setCheckedState: PropTypes.func,
  setCurrentPage: PropTypes.func,
  setId: PropTypes.func,
  length: PropTypes.number,
}

export default AllButton
